import React, { useEffect } from "react";
import styled from "styled-components";
import assets from "../../assets/assets";
import NotificationPopup from "../UI/Login/NotificationPopup";
import { IconController } from "../Scripts/ImgController";
import { Outlet } from "react-router-dom";

const Wrapper = styled.div`
  background: linear-gradient(111.08deg, #111827 0%, #0061ff 100%);
  min-height: 100vh;
  width: 100%;
  position: relative;
  .modal {
    background: #ffffff;
    box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);
    border-radius: 16px;
    padding: 48px 72px;
    width: 540px;
  }
  @media (max-width: 767px) {
    .modal {
      width: calc(100vw - 32px);
      padding: 32px 20px;
    }
  }
  .button {
    background: #0061ff;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-radius: 8px;
  }
  .color-CK {
    color: #007dfa;
  }
  input {
    border: 1px solid #bebebf;
    border-radius: 8px;
    width: 100%;
    padding: 14px 16px;
  }
  .z-102 {
    z-index: 102 !important;
  }
  .z-101 {
    z-index: 101 !important;
  }
  .password-input {
    position: relative;
    height: 100%;
  }
  .password-eye {
    position: absolute;
    right: 0;
    top: 0;
    padding: 16px 12px;
  }
  .password-active {
    border-radius: 9999px;
    background: #bebebf;
  }
  .otp-border {
    border: 1px solid #e0effe;
    text-align: center;
  }
  .border-red {
    border: 1px solid red;
    text-align: center;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const Login = ({ popup, popupType, popupMessage, setPopup }) => {
  useEffect(() => {
    document.title = "MMusic - Нэвтрэх";
  }, []);
  return (
    <Wrapper>
      <div className="w-full min-h-screen relative flex flex-col justify-center items-center py-8 z-102">
        <IconController src={assets.svg.mmusicLogo} alt="" className="pb-8 md:pb-16" />
        <div className="modal">
          <Outlet />
        </div>
        {popup ? (
          <NotificationPopup
            type={popupType}
            popupMessage={popupMessage}
            popup={popup}
            setPopup={setPopup}
            animDirectionTop={true}
          />
        ) : (
          <div className="mt-12 h-16"></div>
        )}
      </div>
      <div className="w-full h-full fixed top-0 z-101">
        {/* Carickao: end animated blob hiih */}
      </div>
    </Wrapper>
  );
};

export default Login;
